import * as serializer from 'basic-editor-value-serializer';
const keys = ['arrangement', 'frame', 'contentWidth', 'gap', 'logoHeight', 'gutter', 'offset', 'treatment', 'initial', 'scrolled'];

export function collect(node) {
  if (node.type !== 'site-nav') {
    return null;
  }
  const value = serializer.utilities.node.siteNav.readSettings(node);
  const result = {};
  for (const key of keys) {
    result[key] = value[key];
  }
  for (const breakpoint of ['tablet', 'mobile']) {
    result[breakpoint] = {};
    for (const key of ['arrangement', 'gap', 'gutter']) {
      if (Object.prototype.hasOwnProperty.call(value[breakpoint], key)) {
        result[breakpoint][key] = value[breakpoint][key];
      }
    }
  }
  return JSON.parse(JSON.stringify(result));
}

export function apply(node, value, styles) {
  if (node.type !== 'site-nav' || !value) {
    return styles;
  }
  const settings = serializer.utilities.node.siteNav.readSettings(node);
  for (const key of keys) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      settings[key] = value[key];
    }
  }
  for (const breakpoint of ['tablet', 'mobile']) {
    settings[breakpoint] = { ...settings[breakpoint], ...value[breakpoint] };
  }
  return { ...styles, properties: { ...node.properties, siteNav: serializer.utilities.node.siteNav.sanitizeSettings(settings) } };
}

const SURFACE_OVERRIDES = { backgroundColor: 'backgroundColor', textColor: 'textColor', border: 'borderColor' };

// The header's own colors and shadow and its before-scrolling ones paint the same bar, and the
// before-scrolling ones win. A color or shadow a person picks for the bar clears the one it would lose to.
export function surfaceAttributes(node, attributes) {
  if (node.type !== 'site-nav') {
    return attributes;
  }
  const settings = serializer.utilities.node.siteNav.readSettings(node);
  const initial = { ...settings.initial };
  for (const key of Object.keys(attributes)) {
    if (Object.prototype.hasOwnProperty.call(SURFACE_OVERRIDES, key)) {
      initial[SURFACE_OVERRIDES[key]] = null;
    }
    if (key === 'boxShadow') {
      initial.shadow = false;
    }
  }
  return { ...attributes, properties: { ...node.properties, siteNav: { ...settings, initial } } };
}
